import React, { useEffect } from "react";
import Navigation from "../Navigation/Navigation";
import HomeFooter from "../HomePage/HomeFooter";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Politika Privatnosti - Malonogometni Turnir";
  }, []);

  return (
    <>
      <Navigation />
      <div className="policy-page">
        <button className="back-btn" onClick={() => window.history.back()}>
          ⬅ Povratak
        </button>
        <div className="policy-container">
          <h1>Politika Privatnosti</h1>
          <p className="last-updated">Zadnja izmjena: Lipanj 2026.</p>

          <section>
            <h2>1. Voditelj obrade podataka</h2>
            <p>
              Organizacijski odbor Malonogometnog turnira Podsused upravlja ovom
              aplikacijom i odgovoran je za obradu vaših osobnih podataka.
            </p>
          </section>

          <section>
            <h2>2. Koje podatke prikupljamo?</h2>
            <p>
              Prikupljamo samo minimalne podatke potrebne za funkcioniranje
              turnira:
            </p>
            <ul>
              <li>
                <strong>Podaci o igračima:</strong> Ime i prezime (na aplikaciji
                prikazano kao Ime i inicijal prezimena), pripadnost timu i
                statistika golova.
              </li>
              <li>
                <strong>Podaci o timovima:</strong> Naziv tima i popis igrača.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Svrha i pravna osnova obrade</h2>
            <p>
              Podatke obrađujemo isključivo u svrhu organizacije sportskog
              natjecanja i informiranja javnosti o rezultatima (legitiman
              interes).
            </p>
          </section>

          <section>
            <h2>4. Sigurnost podataka</h2>
            <p>
              Vaši podaci pohranjeni su u bazi podataka{" "}
              <strong>Supabase</strong>, koja koristi vrhunske standarde
              enkripcije i sigurnosne protokole.
            </p>
          </section>

          <section>
            <h2>5. Vaša prava</h2>
            <p>
              Imate pravo zatražiti ispravak netočnih podataka ili brisanje
              istih (anonimizaciju rezultata) slanjem upita organizatoru.
            </p>
          </section>
          <section>
            <h2>6. Kolačići i tehnologije praćenja</h2>
            <p>
              Ova aplikacija koristi isključivo{" "}
              <strong>tehnički nužne kolačiće</strong>
              (ili lokalnu pohranu preglednika) kako bi omogućila funkcionalnost
              prijave za ovlaštene osobe (administratori i osoblje). Ne
              koristimo kolačiće za oglašavanje ili praćenje vaših navika
              pretraživanja.
            </p>
          </section>

          <section>
            <h2>7. Razdoblje pohrane podataka</h2>
            <p>
              Podaci o ekipama i strijelcima čuvaju se kao povijesni zapis
              turnira. Podaci prikupljeni putem sustava prijave (za osoblje)
              čuvaju se do opoziva ovlaštenja ili prestanka potrebe za pristupom
              sustavu.
            </p>
          </section>

          <section>
            <h2>8. Prijenos podataka trećim stranama</h2>
            <p>
              Vaši podaci se ne prodaju niti dijele s trećim stranama u
              marketinške svrhe. Pristup podacima ima isključivo organizacijski
              odbor putem sigurne infrastrukture pružatelja usluga (Supabase).
            </p>
          </section>
        </div>
      </div>
      <HomeFooter />
    </>
  );
};

export default PrivacyPolicy;
